import React from "react";
import { Maximize2, ArrowRight, Tag, Truck } from "lucide-react";
import { materials } from "../mock/mock";
import { useLightbox } from "../context/LightboxContext";

export default function Materials() {
  const { openLightbox } = useLightbox();
  const lightboxItems = materials.map((m) => ({
    image: m.image,
    title: m.title,
    caption: m.description,
  }));
  return (
    <section id="gallery" className="border-b border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <div className="section-label mb-4">Available Materials</div>
            <h2 className="section-heading text-[30px] sm:text-[36px] md:text-[46px] leading-[1.05]">
              Material Showcase
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-[#b6b3ab] max-w-xl">
              Take a closer look at our high-grade materials and work results
              in the Magic Valley area.
            </p>
          </div>

          <div className="inline-flex items-center gap-2 chip rounded-md px-3 py-2 text-[11.5px] font-semibold tracking-[0.14em] uppercase text-[#c8c5bc]">
            <Truck size={13} className="text-[#c9b98a]" />
            Material Delivery
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {materials.map((m, idx) => (
            <article
              key={m.id}
              className="card-outline rounded-xl overflow-hidden hover-lift group"
            >
              <button
                type="button"
                onClick={() => openLightbox(lightboxItems, idx)}
                className="relative aspect-[4/3] overflow-hidden block w-full text-left"
              >
                <img
                  src={m.image}
                  alt={m.title}
                  className="photo-crisp w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 img-overlay" />
                <div className="absolute top-3 right-3 chip bg-[#0a0a0b]/70 backdrop-blur rounded-md px-2.5 py-1.5 flex items-center gap-1.5 text-[11px] text-[#c8c5bc]">
                  <Maximize2 size={12} />
                  Full Photo
                </div>
              </button>
              <div className="p-6">
                <div className="inline-flex items-center gap-1.5 chip rounded-full px-2.5 py-1 text-[10.5px] font-semibold uppercase tracking-[0.16em] text-[#c9b98a]">
                  <Tag size={11} />
                  {m.category}
                </div>
                <h3 className="mt-3 font-display font-bold text-[20px] text-[#f4efe6]">
                  {m.title}
                </h3>
                <p className="mt-2 text-[13px] text-[#b6b3ab] leading-relaxed">
                  {m.description}
                </p>
                <div className="mt-5 pt-4 border-t divider-soft flex items-center justify-between">
                  <span className="text-[12px] text-[#8a877f]">
                    Direct delivery
                  </span>
                  <a
                    href="#contact"
                    className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-[#f4efe6] hover:text-white group/link"
                  >
                    Get Quote
                    <ArrowRight
                      size={13}
                      className="transition-transform group-hover/link:translate-x-0.5"
                    />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
